import { ControllerModel } from "../_model/ControllerModel";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { SugarCentrifugueBatch } from "./modelSugarCentrifugueBatch";

class ControllerSugarCentrifugueBatch extends ControllerModel {
    constructor() {
        super("ControllerSugarCentrifugueBatch");

        this.setNewNode = (callback) => {
            let sugarCentrifugueBatch = new SugarCentrifugueBatch();
            sugarCentrifugueBatch.decorate(callback);

            this.addNode(sugarCentrifugueBatch);
            SingletonFlowchart.SaveStatus()
        }

        this.loadNode = (node, callback) => {
            let sugarCentrifugueBatch = new SugarCentrifugueBatch();
            sugarCentrifugueBatch.copyFrom(node);
            sugarCentrifugueBatch.decorate(callback);
            this.addNode(sugarCentrifugueBatch)
        }

        this.getProperties = async (node) => {
            let n = new SugarCentrifugueBatch();
            await n.copyFrom(node);
            return n.data
        }

        this.getNode = (node) => {
            let n = new SugarCentrifugueBatch();
            n.copyFrom(node);
            return n
        }
    }
}

export { ControllerSugarCentrifugueBatch };